module.exports = __webpack_public_path__ + "img/clement-apron1.02a6b1aa.png";